import { LocDef, LocDefs, LocMap } from '@cm/core/localization';
import { HubFeature } from '@ats/api/cm';

const pathStart = 'System Settings|Tagging|Tagging Items|Untagged Items|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Tagging,
	portal: 'SP',
};

type LocNameStart = 'SPUntaggedItems';
export type SPUntaggedItemsLocNames =
	| `${LocNameStart}TitleSection`
	| `${LocNameStart}ButtonAddToNewTag`
	| `${LocNameStart}ButtonAddToExistingTag`
	| `${LocNameStart}LabelFilterByType`
	| `${LocNameStart}LabelName`
	| `${LocNameStart}LabelExternalId`
	| `${LocNameStart}LabelType`;

export const spUntaggedItemsLocs: LocDefs<SPUntaggedItemsLocNames> = {
	SPUntaggedItemsTitleSection: {
		defaultValue: 'Untagged Items',
		description: 'Untagged Items title.',
		displayPath: `${pathStart}Section Title`,
		displayType: 'Title',
		// legacyName: 'Tagging/SystemSettings.TaggingItems.TaggedItems.Title.UntaggedItems',
		...sharedProperties,
	},
	SPUntaggedItemsButtonAddToNewTag: {
		defaultValue: 'Add New Tag to Selected Items',
		description: 'Add New Tag to Selected Items button.',
		displayPath: `${pathStart}Add New Tag to Selected Items`,
		displayType: 'Button',
		// legacyName: 'Tagging/SystemSettings.TaggingItems.TaggedItems.Button.AddNewTag',
		...sharedProperties,
	},
	SPUntaggedItemsButtonAddToExistingTag: {
		defaultValue: 'Add Existing Tag to Selected Items',
		description: 'Add Existing Tag to Selected Items button.',
		displayPath: `${pathStart}Add Existing Tag to Selected Items`,
		displayType: 'Button',
		// legacyName: 'Tagging/SystemSettings.TaggingItems.TaggedItems.Button.AddExistingTag',
		...sharedProperties,
	},
	SPUntaggedItemsLabelFilterByType: {
		defaultValue: 'Filter by Type',
		description: 'Label for Filter by Type.',
		displayPath: `${pathStart}Filter by Type`,
		displayType: 'Label',
		// legacyName: 'Tagging/SystemSettings.TaggingItems.TaggedItems.FieldLabel.FilterByType',
		...sharedProperties,
	},
	SPUntaggedItemsLabelName: {
		defaultValue: 'Name',
		description: 'Column heading for: Name.',
		displayPath: `${pathStart}Name`,
		displayType: 'Label',
		// legacyName: 'Tagging/SystemSettings.TaggingItems.TaggedItems.ColumnHeading.Name',
		...sharedProperties,
	},
	SPUntaggedItemsLabelExternalId: {
		defaultValue: 'External ID',
		description: 'Column heading for: External ID.',
		displayPath: `${pathStart}External ID`,
		displayType: 'Label',
		// legacyName: 'Tagging/SystemSettings.TaggingItems.TaggedItems.ColumnHeading.ExternalId',
		...sharedProperties,
	},
	SPUntaggedItemsLabelType: {
		defaultValue: 'Type',
		description: 'Column heading for: Type.',
		displayPath: `${pathStart}Type`,
		displayType: 'Label',
		// legacyName: 'Tagging/SystemSettings.TaggingItems.TaggedItems.ColumnHeading.Type',
		...sharedProperties,
	},
};

export type SPUntaggedItemsLocType = LocMap<SPUntaggedItemsLocNames>;
